import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import FormClient from './components/FormClient/index';

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://286cdfe8300f8c5eb14349241e49b79c@o4507306105372672.ingest.de.sentry.io/4507327697649745",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  // Session Replay
  replaysSessionSampleRate: 0, // Disable session recording
  replaysOnErrorSampleRate: 0, // Disable session recording on error
  beforeSend(event) {
    // List of allowed patterns to match URLs of scripts you want to track
    const allowedPatterns = [
      /https:\/\/storage\.googleapis\.com\/bucket-khc-gcp-prod-01-fr-form-client\/prod\/dist\/bundle\.js/,
      /https:\/\/storage\.googleapis\.com\/bucket-khc-gcp-prod-01-fr-form-client\/dev\/dist\/bundle\.js/
    ];

    // Helper function to check if a URL matches any of the allowed patterns
    const isAllowedEvent = (url) => allowedPatterns.some(pattern => pattern.test(url));

    // Check if the event contains any exceptions with frames that should be allowed
    if (event.exception && event.exception.values) {
      for (const value of event.exception.values) {
        if (value.stacktrace && value.stacktrace.frames) {
          for (const frame of value.stacktrace.frames) {
            if (frame.abs_path && isAllowedEvent(frame.abs_path)) {
              // If any frame matches the allowed patterns, send the event
              return event;
            }
          }
        }
      }
    }

    // Check if the event contains any errors with URLs that should be allowed
    if (event.errors) {
      for (const error of event.errors) {
        if (error.url && isAllowedEvent(error.url)) {
          // If any error matches the allowed patterns, send the event
          return event;
        }
      }
    }

    // If no allowed patterns matched, discard the event
    return null;
  },
});

export function RenderWidget({element}) {
  const [uuid, setUuid] = useState();

  useEffect(()=> { 
    const dataUuid = element.getAttribute('data-uuid');
    setUuid(dataUuid);
  },[element])

  return (
    <FormClient uuid={uuid}/>
  )
}

window.onload = function() {
  const elements = document.getElementsByClassName('khc-form-client');

  if (elements.length) {
    Array.from(elements).forEach((element) => {
      const root = ReactDOM.createRoot(element);
      
      root.render(
        <React.StrictMode>
          <RenderWidget element={element} />
        </React.StrictMode>
      );
    });
  }
}
